import currentUser from '../services/current_user';
import OAuth from '../services/oauth';

export const Services = {
  currentUser,
  OAuth,
};
